<template>
  <section class="print-pages">

    <div class="invoice-ttl">
      <h2>請求書</h2>
      <dl>
        <div class="flex">
          <dt>発行日</dt>
          <dd>:  {{ billing?.getBillingConfirmationDateText("YYYY年MM月DD日") }}</dd>
        </div>
        <div class="flex">
          <dt>ご請求番号</dt>
          <dd>: EN-{{ billing?.getBillingDateText("YYYYMMDD") }}-{{ billing?.billingId }}</dd>
        </div>
      </dl>
    </div>

    <div class="invoice-info">
      <div>
        <ul class="list-unstyled">
          <li>〒{{ organization?.billingAddress.getPostalCodeText() }}</li>
          <li>{{ organization?.billingAddress.getAddressText() }}</li>
        </ul>
        <ul class="list-unstyled mt-4">
          <li>{{ organization?.billingAddress?.companyName }} 様</li>
          <li>下記の通り、請求いたします。</li>
        </ul>
      </div>

      <div class="address">
        <ul class="list-unstyled">
          <li><img src="@/assets/img/logo_novars.png" alt="NOVARSロゴ" class="logo"></li>
          <li>ノバルス株式会社</li>
          <li>〒101-0054</li>
          <li>東京都千代田区神田錦町三丁目15番地</li>
          <li>錦町ブンカイサン3F</li>
        </ul>
        <div><img src="@/assets/img/stamp.png" alt="はんこ" class="stamp"></div>
      </div>
    </div>

    <div class="invoice-transfer">
      <dl>
        <div>
          <dt>ご請求金額：</dt>
          <dd>{{ billing?.billingAmountIncludingTax.toLocaleString() }} 円（税込）</dd>
        </div>
        <div>
          <dt>お支払期日：</dt>
          <dd>{{ billing?.getBillingConfirmationDateText("YYYY年MM月") }}末日</dd>
        </div>
        <div>
          <dt>お振込先：</dt>
          <dd>三井住友銀行　新橋支店（普通）2356710　【口座名義】ノバルス(カ</dd>
          <p>※お振込手数料は貴社ご負担にてお願い致します。</p>
        </div>
      </dl>
    </div><!-- /.invoice-transefer -->

    <div class="invoice-list">
      <ul class="row list-unstyled small list-head">
        <li class="col-7">内容</li>
        <li class="col-2 text-end">単価（税別）</li>
        <li class="col-1 text-end">数量</li>
        <li class="col-2 text-end">金額（税別）</li>
      </ul>

      <ul
        class="list-unstyled invoice-detail"
        v-if="billingItems.length > 0"
      >
        <li class="row" :key="index" v-for="(billingItem, index) in billingItems">
          <div class="col-7">{{ billingItem?.billingItemName }}</div>
          <div class="col-2 text-end">{{ billingItem?.billingAmount.toLocaleString() }} 円</div>
          <div class="col-1 text-end">1</div>
          <div class="col-2 text-end">{{ billingItem?.billingAmount.toLocaleString() }} 円</div>
        </li>
      </ul>

    </div>

    <dl class="invoice-amount">
      <div class="flex">
        <dt>小計</dt>
        <dd>{{ billing?.billingAmount.toLocaleString() }} 円</dd>
      </div>
      <div class="flex">
        <dt>税</dt>
        <dd>{{ billing?.billingTax.toLocaleString() }} 円</dd>
      </div>
      <div class="flex total">
        <dt>総計</dt>
        <dd>{{ billing?.billingAmountIncludingTax.toLocaleString() }} 円</dd>
      </div>
    </dl>

  </section>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
// import NotificationRecipient from "models/notification-recipient";

import { CrossIcon, SendIcon, DownloadIcon } from "icons";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

import { Billing, BillingItem } from "models/billing";

const BillingsRepository = RepositoryFactory.get("billings");
const OrganizationsRepository = RepositoryFactory.get("organizations");

export default {
  name: "BillingsInvoice",
  components: {
  },
  data() {
    return {
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      icons: {
        CrossIcon,
        SendIcon,
        DownloadIcon,
      },
      organization: null,
      billing: null,
      billingItems: [],
      formItems: {
        notificationRecipient: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
    }),
  },
  async created() {
    /* 初期化処理 */
    try {
      // 監視対象一覧の取得
      this.items = [];
      const billingRecord = await BillingsRepository.get(
        this.currentServiceAccount.serviceAccountId,
        this.$route.params.id,
      );
      this.billing = Billing.createInstance(billingRecord);
      console.log(this.billing);

      const billingItemRtemRecords = await BillingsRepository.getBillingItems(
        this.currentServiceAccount.serviceAccountId,
        this.$route.params.id,
      );
      billingItemRtemRecords.forEach((item) => {
        this.billingItems.push(BillingItem.createInstance(item));
      });
      this.organization = await OrganizationsRepository.get(
        this.currentServiceAccount.serviceAccountId,
      );

      // 画面機能を有効化
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setNotification: "notification/setNotification",
      setErrorNotification: "notification/setErrorNotification",
    }),
    downloadPdf(paymentHistory) {
      alert(paymentHistory.billingId);
    },
  },
};
</script>
